import Table from "components/utils/Table";
import PermissionAbility from "helpers/PermissionAbility";
import { useState } from "react";
import Moment from "react-moment";
import { Link, useNavigate } from "react-router-dom";
import InvoiceService from "services/InvoiceService";
import InvoiceFilter from "./InvoiceFilter";
import Confirmation from "components/utils/Confirmation";


const ServiceInvoices = () => {
  const [loading, setLoading] = useState(true);
  const [invoices, setInvoices] = useState([]);
  const [filter, setFilter] = useState(false);
  const [filterValue, setFilterValue] = useState(null);
  const [block, setBlock] = useState(false);
  const [invoiceId, setInvoiceId] = useState({});
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);

  const filterdata = (data) => {
    setFilter(false);
    setFilterValue(data);
    getInvoices(data);
  };

  const getInvoices = async (filters) => {
    setInvoices(await InvoiceService.getAllService(filters));
    setLoading(false);
  };

  const exportInvoice = async () => {
    setBlock(true);
    let data = await InvoiceService.serviceInvoiceExport(filterValue);
    window.location.href = data;
    setBlock(false);
  };

  let navigate = useNavigate();

  const deleteServiceInvoice = (invoiceId) => {
    InvoiceService.removeService(invoiceId);
    getInvoices();
    setLoading(false);
  };

  const columns = [
    {
      name: "Id",
      selector: (row) => row?.invoice_number,
      sortable: true,
      field: "id",
    },
    {
      name: "Company",
      selector: (row) => row?.company?.name,
      sortable: true,
      field: "name",
      format: (row) => (
        <div className="d-flex align-items-center">
          <div className="d-flex justify-content-start flex-column">
            <Link
              to={"/panel/companies/" + row?.company?.id}
              className="text-dark fw-bolder text-hover-primary"
            >
              {row?.company?.name}
            </Link>
          </div>
        </div>
      ),
    },
    {
      name: "Requisition Type",
      selector: (row) =>
        row?.previous_due
          ? "Previous Due"
          : row?.type?.replaceAll("_", " ")?.capitalize(),
      sortable: true,
      field: "id",
    },

    {
      name: "Total",
      selector: (row) => row?.grand_total,
      sortable: true,
      field: "total_due",
      format: (row) => (
        <div className="mt-2">{ row?.grand_total} tk</div>
      ),
    },

    {
      name: "Vat & Others",
      selector: (row) => row?.grand_total,
      sortable: true,
      field: "total_due",
      format: (row) => (
        <div className="mt-2">{ row?.grand_total-row?.sub_total} tk</div>
      ),
    },

    {
      name: "Paid",
      selector: (row) => row?.totalPaid,
      sortable: true,
      field: "total_due",
      format: (row) => (
        <div className="mt-2">
          {row?.totalPaid ? parseInt(row?.totalPaid) : 0} tk
        </div>
      ),
    },

    {
      name: "Status",
      selector: (row) => row?.status,
      sortable: true,
      field: "status",
      format: (row) => (
        <div className="mt-2">
          {row?.status.replaceAll("_", " ")?.capitalize()}
        </div>
      ),
    },

    {
      name: "AIT/VAT",
      selector: (row) => row?.vat_ait_received,
      sortable: true,
      field: "vat_ait_received",
      format: (row) => (
        <div className="mt-2">
          {row?.vat_ait_received
            ? "Received"
            : "Not Paid"}
        </div>
      ),
    },

    {
      name: "Created At",
      selector: (row) => row?.created_at,
      sortable: true,
      field: "created_at",
      format: (row) => (
        <div className="mt-2">
          <Moment format="D MMMM YYYY">{row?.created_at}</Moment>
        </div>
      ),
    },

    {
      name: "Action",
      selector: (row) => row.status,
      width: "15%",
      format: (row) => (
        <>
          <span className="text-end">
            <PermissionAbility permission="service_invoices_show">
              <Link
                to={"/panel/services-invoice/" + row.id}
                className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
              >
                <i className="fa fa-eye"></i>
              </Link>
            </PermissionAbility>
          </span>
          {!row?.previous_due && (
            <>
              <span className="text-end">
                <PermissionAbility permission="service_invoices_print">
                  <Link
                    to={"/panel/service-invoices/" + row.id + "/print"}
                    className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                    target="_blank"
                  >
                    <i className="fa fa-print"></i>
                  </Link>
                </PermissionAbility>
              </span>
            </>
          )}

          <PermissionAbility permission="service_invoice_delete">
            <Link
              to="#"
              className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
              onClick={() => {
                setInvoiceId(row.id);
                setConfirmDelete(true);
              }}
            >
              <i className="fa fa-trash"></i>
            </Link>
          </PermissionAbility>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="post d-flex flex-column-fluid">
        <div className="container-xxl">
          <Table
            name="Quotations"
            // buttonName="Filter"
            // onClickButton={() => {
            //   setFilter(!filter);
            // }}
            onClickButton={onOpenModal}

            callbackButtons={[
              {
                name: "Filter",
                callback: () => {
                  setFilter(!filter);
                },
                permission: null,
              },
              {
                name: "Export",
                callback: () => {
                  exportInvoice();
                },
                permission: null,
              },
            ]}
            isLoading={loading}
            data={invoices}
            columns={columns}
            onFilter={getInvoices}
            buttonPermission="invoices_create"
          />
        </div>
      </div>
      <InvoiceFilter
        enable={filter}
        onClickOutside={() => {
          setFilter(!filter);
        }}
        onChange={(data) => {
          filterdata(data);
        }}
      />
      <Confirmation
        open={confirmDelete}
        onConfirm={() => {
          setConfirmDelete(false);
          deleteServiceInvoice(invoiceId);
        }}
        onCancel={() => setConfirmDelete(false)}
      />
    </>
  );
};

export default ServiceInvoices;
